import { createContext, useContext, useState, useCallback, ReactNode } from 'react';

export type OtaStatus = 'idle' | 'checking' | 'downloading' | 'applying' | 'success' | 'error';

interface OtaUpdateState {
  status: OtaStatus;
  version: string | null;
  progress: string | null;
  setOtaStatus: (status: OtaStatus, version?: string, progress?: string) => void;
  clearStatus: () => void;
}

const OtaUpdateContext = createContext<OtaUpdateState>({
  status: 'idle',
  version: null,
  progress: null,
  setOtaStatus: () => {},
  clearStatus: () => {},
});

export const useOtaUpdate = () => useContext(OtaUpdateContext);

export const OtaUpdateProvider = ({ children }: { children: ReactNode }) => {
  const [status, setStatus] = useState<OtaStatus>('idle');
  const [version, setVersion] = useState<string | null>(null);
  const [progress, setProgress] = useState<string | null>(null);

  const setOtaStatus = useCallback((s: OtaStatus, v?: string, p?: string) => {
    setStatus(s);
    if (v) setVersion(v);
    if (p !== undefined) setProgress(p);
  }, []);

  const clearStatus = useCallback(() => {
    setStatus('idle');
    setVersion(null);
    setProgress(null);
  }, []);

  return (
    <OtaUpdateContext.Provider value={{ status, version, progress, setOtaStatus, clearStatus }}>
      {children}
    </OtaUpdateContext.Provider>
  );
};
